import React from 'react';
import styles from './LayoutOut.module.css';

const LayoutOut = ({ children }) => {
    return (
        <div className={styles.LayoutOut} data-theme="dark">
            <div className={styles.contentOut}>{children}</div>
        </div>
    );
};

export default LayoutOut;
